export const SET_USER_DATA = "SET_USER_DATA";
export const SET_NOTIFICATION_DATA = "SET_NOTIFICATION_DATA";
